import React from 'react'
import './DosriBari.css'

const DosriBari = () => {
  return (
<div>
    <div className="parent5">

        <div className="div23">
            <img src="https://shop.activeitzone.com/public/uploads/all/BNSKIwvHFHpi7CV0UgRfwtkRFBF5mMZFlhGwh0kE.webp" height={300} width="100%" alt="" /> 
        </div>

        <div className="div24">
            <img src="https://shop.activeitzone.com/public/uploads/all/jOYnXcAq73lbhvD1KLIS7kjVwTZooYF1JKo2Z5RJ.webp" height={300} width="100%" alt="" />
         </div>
    </div>

    <div>
      <h2>Baby & Kids</h2>
    </div>

</div>
  )
}

export default DosriBari